import React from 'react';
import { connect } from 'react-redux';
import { Spacer } from '@zillow/constellation';

import ListingTour from 'app/shared/components/postingPath/ListingTour';
import ListingStatus from 'app/shared/components/postingPath/ListingStatus';
import FloorplansMF from 'app/shared/components/postingPath/FloorplansMF';
import UnitsSection from 'app/shared/components/postingPath/UnitsSection';
import userUtils from 'app/shared/utils/userUtils';
import { AppSelectors, UserSelectors } from 'app/shared/selectors';
import { StyledHR } from 'app/shared/StyledComponents/StyledComponents';

const NotViewableContent = ({
    errorObj,
    formData,
    getActiveFloorplanOrUnitCount,
    isAddingUnit,
    isArchived,
    isListingPhotoProcessing,
    isScreenSM,
    isScreenXS,
    saveFloorplanData,
    updateErrorObj,
    updateFormData,
    updateListingPhotoProcessingStatus,
    updateParentFloorplanPrice,
    updateOnFocus,
    updateStatusMessage,
    user,
    validateFloorplan,
    validateFloorplans,
    validateUnit,
}) => {
    const {
        active,
        isFeed,
        isEditable,
        isPaidMultifamily,
        isCommunity,
        restrictions: {
            isUpdateListingRestricted,
        },
        syndication,
    } = formData;
    const { roles, features: { canUpdateListing } } = user;
    const isInputFormDisabled = isArchived || isUpdateListingRestricted;
    const isAdmin = userUtils.isPostingPathAdmin(roles);
    const hasFloorPlans = formData.floorplans.length > 0;
    const showFloorPlans = hasFloorPlans && isCommunity;
    const hasUnits = formData.units.length > 0;
    const isListingFooterVisible = isEditable && canUpdateListing && (!isPaidMultifamily || isAdmin);

    return (
        <Spacer paddingX={0} className="EditListingPage-NotEditable-Container">
            {(isCommunity || isFeed) && active && !isListingFooterVisible && (
                <ListingStatus syndication={syndication} />
            )}
            <ListingTour
                tours={formData.tours}
                tourType={isCommunity ? 'amenity' : 'singleFamily'}
                isDisabled={isInputFormDisabled}
                updateStatusMessage={updateStatusMessage}
                updateFormData={updateFormData}
                formData={formData}
            />
            {(showFloorPlans || hasUnits) && (
                <React.Fragment>
                    <StyledHR />
                    {showFloorPlans && (
                        <FloorplansMF
                            canEditTourOverwrite={!isInputFormDisabled}
                            errorObj={errorObj}
                            formData={formData}
                            getActiveFloorplanOrUnitCount={getActiveFloorplanOrUnitCount}
                            isAddingUnit={isAddingUnit}
                            isInputFormDisabled={true}
                            isListingPhotoProcessing={isListingPhotoProcessing}
                            isMobile={isScreenXS || isScreenSM}
                            isPostingPathAdmin={isAdmin}
                            propertyId={formData.propertyId}
                            saveFloorplanData={saveFloorplanData}
                            updateErrorObj={updateErrorObj}
                            updateFormData={updateFormData}
                            updateListingPhotoProcessingStatus={updateListingPhotoProcessingStatus}
                            updateOnFocus={updateOnFocus}
                            updateParentFloorplanPrice={updateParentFloorplanPrice}
                            updateStatusMessage={updateStatusMessage}
                            validateFloorplan={validateFloorplan}
                            validateFloorplans={validateFloorplans}
                            validateUnit={validateUnit}
                        />
                    )}
                    {hasUnits && (
                        <UnitsSection
                            formData={formData}
                            isMobile={isScreenXS || isScreenSM}
                            isPostingPathAdmin={isAdmin}
                            isInputFormDisabled={true}
                            canEditTourOverwrite={!isInputFormDisabled}
                        />
                    )}
                </React.Fragment>
            )}
        </Spacer>
    );
};

const mapStateToProps = state => ({
    isScreenXS: AppSelectors.makeIsScreenXS(state),
    isScreenSM: AppSelectors.makeIsScreenSM(state),
    user: UserSelectors.makeUser(state),
});


export default connect(mapStateToProps)(NotViewableContent);
